module.exports = __webpack_public_path__ + "static/media/LegoShadowTheatreINTA0067_design_clean_v001.e2dab8dd.png";